module.exports = __webpack_public_path__ + "static/media/logo.cf68e66c.png";